<template>
  <FormInput v-model="modelValue" :name :left-icon="iconUser" :placeholder="$t('LoginOrReg.AccountTips')" autocomplete="off" autocapitalize="off"
    :formatter="formatAccount" :rules="[
      {
        validator: validatePhoneNumber,
        message: $t('LoginOrReg.AccountErrorTips'),
        trigger: 'onChange',
      },
    ]">
  </FormInput>
</template>

<script setup lang="ts">
  // import { validateAccount } from '@/utils/validate'
  import iconUser from '@a/assets/images/i_user.png'
  import FormInput from '@a/components/FormInput'

  withDefaults(
    defineProps<{
      name?: string
    }>(),
    {
      name: 'username',
    },
  )

  const validatePhoneNumber = (value: string) => {
    return value.trim().length === 11
  }

  const modelValue = defineModel<string>()

  const formatAccount = (value: string) => {
    return value.replace(/\D/g, '');
  }
</script>
